import { render, staticRenderFns } from "./ApprovalLabel.vue?vue&type=template&id=5391415a&"
import script from "./ApprovalLabel.vue?vue&type=script&lang=js&"
export * from "./ApprovalLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports